export const getErr = (err: Error | unknown): string =>
  err instanceof Error ? err.message : String(err);
